import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { TimelineMax } from 'gsap';
import ScrollMagic from 'scrollmagic';
import { Layout } from '../components/Layout';
import { Slider } from '../components/Slider';
import { StickyTag } from '../components/StickyTag';
import { FullWidthImage } from '../components/FullWidthImage';
import { Text } from '../components/Text';
import { CustomButton, PrimaryButton } from '../components/Buttons/';
import { Carousel } from '../components/Carousel';
import IMG_2259 from '../assets/images/About/IMG_2259.jpg';
import IMG_2611 from '../assets/images/About/IMG_2611.jpg';
import IMG_2676 from '../assets/images/About/IMG_2676.jpg';
import IMG_2753 from '../assets/images/About/IMG_2753.jpg';
import IMG_2128 from '../assets/images/About/IMG_2128.jpg';
import shinyAndroid from '../assets/images/ShinyThings/android.jpg';
import shinyPasha1 from '../assets/images/awards-01.png';
import shinyPasha2 from '../assets/images/awards-02.png';
import shinyPasha3 from '../assets/images/awards-03.png';
import shinyPasha4 from '../assets/images/awards-04.png';
import shinyPasha5 from '../assets/images/awards-05.png';
import shinyPasha6 from '../assets/images/awards-06.png';

const SectionOurStory = styled.div`
  font-family: Avenir;
  padding: 30px 40px;
  margin-top: 10px;

  @media (max-width: 576px) {
    padding: 20px 20px;
  }
`;
const SectionOurCrew = styled.div`
  min-height: 600px;
`;
const SectionShinyThings = styled.div`
  min-height: 600px;
`;
const OurStoryText = styled.div`
  font-size: 44px;
  font-weight: 900;
  color: #1d1d1d;
  letter-spacing: -0.15px;
  display: inline;
  font-family: AvenirMedium;

  @media (max-width: 576px) {
    font-size: 26px;
  }
`;

const CareerButton = styled.div`
  margin: 15px 0 0 auto;
  text-decoration: 'none';
  width: max-content;
  display: block;

  @media (max-width: 576px) {
    margin: unset;
  }
`;
const OurStorySubText = styled.div`
  color: #8d848d;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.15px;
  padding-top: 30px;

  @media (max-width: 576px) {
    font-size: 16px;
  }
`;

const MainWrapper = styled.div`
  .ourStory,
  .crew,
  .fullImage,
  .crew,
  .awards,
  .slider {
    opacity: 0;
  }
`;

const ShinyThingsImage = styled.div`
  background-image: url(${(props) => props.src});
  float: left;
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  margin: 1.66%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
`;
const ShinyThingsTextRow = styled.div`
  align-content: flex-end;
  padding-bottom: 20px;
`;

const OurStoryTextHighlight = styled.span`
  background: linear-gradient(to right, rgb(254, 187, 57) 50%, transparent 50%) 105% / 210%
    no-repeat;
  background-repeat: no-repeat;
  background-position-x: 100%;
`;

const StyledStickyTagWrapper = styled.div`
  position: absolute;
  top: 90px;
  margin-left: -48px;
  z-index: 2;

  @media (max-width: 769px) {
    display: none;
  }
`;

const SpacerDiv = styled.div`
  height: 90px;

  @media (max-width: 991px) {
    height: 70px;
  }

  @media (max-width: 576px) {
    height: 50px;
    display: ${(props) => (props.only === 'desktop' ? 'none' : 'block')};
  }
`;

const SmallSpacerDiv = styled.div`
  height: 50px;

  @media (max-width: 991px) {
    height: 40px;
  }

  @media (max-width: 576px) {
    height: 30px;
    display: ${(props) => (props.only === 'desktop' ? 'none' : 'block')};
  }
`;

const sliderData = [
  {
    url: 'IMG_9180.jpg',
    text: 'Virtual tour of our space station',
  },
  {
    url: 'IMG_8819.jpg',
    text: 'Virtual tour of our space station',
  },
  {
    url: 'IMG_9270.jpg',
    text: 'Virtual tour of our space station',
  },
  {
    url: 'IMG_9251.jpg',
    text: 'Virtual tour of our space station',
  },
  {
    url: 'IMG_9040.jpg',
    text: 'Virtual tour of our space station',
  },
];

const carouselData = [
  {
    id: 1,
    url: IMG_2753,
    text: '2D & 3D Artists',
  },
  {
    id: 2,
    url: IMG_2676,
    text: 'Creative Marketing',
  },
  {
    id: 3,
    url: IMG_2611,
    text: 'Game Engineers',
  },
  {
    id: 4,
    url: IMG_2259,
    text: 'Content & Game Designers',
  },
  {
    id: 5,
    url: IMG_2128,
    text: 'QA Analysts',
  },
];

const AboutPage = (props) => {
  const [stickyText, changeStickyText] = useState('This Is Our Story');
  const [stickyVisibility, changeStickyVisibility] = useState(true);

  const storyRef = useRef(null);
  const crewRef = useRef(null);
  const awardsRef = useRef(null);
  const sliderRef = useRef(null);
  const fullImageRef = useRef(null);
  // const gameEngRef = useRef(null);
  // GSAP Animations
  const textHighlightAnimation = () => {
    var textAnimation = new TimelineMax();
    textAnimation.to('.testTextAnimation', 1, {
      'background-position-x': '0%',
    });
    textAnimation.to('.testTextAnimation', 1, {
      'background-position-x': '-100%',
    });
  };
  const sectionAnimation = (sectionName) => {
    var t2 = new TimelineMax();
    t2.staggerFromTo(
      '.' + sectionName + ', .' + sectionName + ' .row',
      1,
      { x: 0, y: 200 },
      { x: 0, y: 0, opacity: 1 },
    );
  };

  if (typeof window !== `undefined`) {
    var controller = new ScrollMagic.Controller();
  }

  useEffect(() => {
    new ScrollMagic.Scene({
      triggerElement: '.testTextAnimation',
      triggerHook: 0.7,
    })
      .on('enter', function() {
        textHighlightAnimation();
      })
      .addTo(controller);
    new ScrollMagic.Scene({
      triggerElement: '.ourStory',
      reverse: false,
      triggerHook: 0.7,
    })
      .on('enter', function() {
        if (storyRef.current) {
          sectionAnimation('ourStory');
        }
      })
      .addTo(controller);
    new ScrollMagic.Scene({
      triggerElement: '.fullImage',
      reverse: false,
      triggerHook: 0.7,
    })
      .on('enter', function() {
        if (fullImageRef.current) {
          sectionAnimation('fullImage');
        }
      })
      .addTo(controller);
    new ScrollMagic.Scene({
      triggerElement: '.crew',
      reverse: false,
      triggerHook: 0.7,
    })
      .on('enter', function() {
        if (crewRef.current) {
          sectionAnimation('crew');
        }
      })
      .addTo(controller);
    new ScrollMagic.Scene({
      triggerElement: '.awards',
      reverse: false,
      triggerHook: 0.7,
    })
      .on('enter', function() {
        if (awardsRef.current) {
          sectionAnimation('awards');
        }
      })
      .addTo(controller);
    new ScrollMagic.Scene({
      triggerElement: '.slider',
      reverse: false,
      triggerHook: 1,
    })
      .on('enter', function() {
        if (sliderRef.current) {
          sectionAnimation('slider');
        }
        changeStickyVisibility(!stickyVisibility);
      })
      .addTo(controller);

    return () => controller.destroy(true);
  }, []);

  return (
    <React.Fragment>
      <Layout>
        <MainWrapper>
          <div className='container'>
            {stickyVisibility && (
              <StyledStickyTagWrapper id='sticky'>
                <StickyTag text={stickyText} location='left' />
              </StyledStickyTagWrapper>
            )}
            <SectionOurStory className='ourStory' ref={storyRef}>
              <div className='row'>
                <div className='col offset-lg-1'>
                  <SpacerDiv only='desktop' />
                  <SmallSpacerDiv only='desktop' />
                  <OurStoryText>
                    All we ever want to do at we.R.play is to&nbsp;
                    <OurStoryTextHighlight className='testTextAnimation'>
                      'Play and let Play'
                    </OurStoryTextHighlight>{' '}
                    and by doing so we are empowering great, talented people to create amazing and
                    flawless experiences for you.
                  </OurStoryText>
                  <OurStorySubText>
                    Scroll down to learn about our space station and crewmembers.
                  </OurStorySubText>
                </div>
              </div>
            </SectionOurStory>
            <div className='fullImage' ref={fullImageRef}>
              <FullWidthImage src='IMG_8750.jpg' />
            </div>
            <SpacerDiv />
            <SectionOurCrew className='crew' ref={crewRef}>
              <Text type='h1' textString='Our crewmembers' />
              <div className='row'>
                <div className='col-md-3'>
                  <Text
                    type='p'
                    textString='The crewmembers (team) are coming from different planets (departments) with their specific skillsets, to collaborate, create, innovate and solve problems of vast scopes.'
                  />
                </div>
                <div className='col-md-3'>
                  <Text
                    type='p'
                    textString='Often people from earth and other planets (clients) come to the space station to collaborate with the crewmembers, to be a part of wonders.'
                  />
                </div>
              </div>
              <Carousel data={carouselData} />
              <CareerButton href='https://sites.google.com/a/werplay.com/careers/' target='_blank'>
                <PrimaryButton text='Careers' invert />
              </CareerButton>
            </SectionOurCrew>
            <SpacerDiv />
            <SmallSpacerDiv />
            <SectionShinyThings className='awards' ref={awardsRef}>
              <Text type='h1' textString='We collect shiny things ' />
              <div className='row'>
                <div className='col-6 col-md-4 col-lg-2'>
                  <ShinyThingsImage src={shinyPasha1}></ShinyThingsImage>
                </div>
                <div className='col-6 col-md-4 col-lg-2'>
                  <ShinyThingsImage src={shinyPasha2}></ShinyThingsImage>
                </div>
                <div className='col-6 col-md-4 col-lg-2'>
                  <ShinyThingsImage src={shinyPasha3}></ShinyThingsImage>
                </div>
                <div className='col-6 col-md-4 col-lg-2'>
                  <ShinyThingsImage src={shinyPasha4}></ShinyThingsImage>
                </div>
                <div className='col-6 col-md-4 col-lg-2'>
                  <ShinyThingsImage src={shinyPasha5}></ShinyThingsImage>
                </div>
                <div className='col-6 col-md-4 col-lg-2'>
                  <ShinyThingsImage src={shinyPasha6}></ShinyThingsImage>
                </div>
              </div>
              <SmallSpacerDiv />
              <ShinyThingsTextRow className='row'>
                <div className='col-12 col-sm-6 order-1 order-sm-0 '>
                  <PrimaryButton
                    text='Contact Us'
                    to='/contact'
                    invert
                    style={{ position: 'absolute', bottom: '7px' }}
                  />
                </div>
                <div className='col-12 col-sm-6 order-0 order-sm-0 my-4 my-sm-0 py-4 py-sm-0'>
                  <Text
                    textString={
                      "Did you know that around 40% of the people working at we.R.play are females? In fact, we've won multiple Pasha ICT Awards for our Gender Diversity!"
                    }></Text>
                </div>
              </ShinyThingsTextRow>
              <SmallSpacerDiv />
            </SectionShinyThings>
            <div className='slider' ref={sliderRef}>
              <Slider data={sliderData} />
            </div>
          </div>
        </MainWrapper>
      </Layout>
    </React.Fragment>
  );
};

export default AboutPage;
